function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  colorInterpolationFilters: "auto",
  id: "atoms-icon-switch_inline_svg__a"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-140 -23)",
  filter: "url(#atoms-icon-switch_inline_svg__a)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M155.293 30.381a.395.395 0 01.597.042c.555.738.86 1.635.86 2.577 0 2.298-1.81 4.178-4.07 4.273l-.18.004h-6.086l1.635 1.646a.4.4 0 01.087.43l-.036.07-.05.062-.148.148a.394.394 0 01-.498.051l-.062-.05-2.561-2.578a.4.4 0 01-.05-.5l.05-.063 2.561-2.577a.394.394 0 01.498-.051l.062.05.147.149a.4.4 0 01.051.5l-.05.062-1.636 1.646h6.086c1.68 0 3.066-1.29 3.233-2.938l.013-.166.004-.168c0-.712-.227-1.39-.642-1.95a.4.4 0 01-.01-.463l.047-.056.148-.15zm.164.082a.229.229 0 01.3.06 4.11 4.11 0 01.826 2.477c0 2.267-1.832 4.11-4.083 4.11h-6.286l-.059.143 1.776 1.787.038.05a.233.233 0 01-.038.278l-.147.148-.049.037a.228.228 0 01-.275-.037l-2.56-2.578-.038-.05a.233.233 0 01.037-.277l2.561-2.578.049-.037c.087-.05.2-.038.275.037l.147.148.038.05a.233.233 0 01-.038.278l-1.776 1.787.06.142h6.285l.17-.004c1.806-.09 3.247-1.596 3.247-3.434 0-.748-.24-1.46-.675-2.049a.233.233 0 01.021-.303l.149-.149zm-2.861-4.147l.062.05 2.561 2.578a.4.4 0 01.05.5l-.05.063-2.561 2.577a.395.395 0 01-.498.051l-.062-.05-.147-.149a.4.4 0 01-.051-.5l.05-.062 1.635-1.646H147.5c-1.68 0-3.066 1.29-3.233 2.938l-.013.166-.004.168c0 .712.227 1.39.642 1.95a.4.4 0 01.01.463l-.047.056-.149.15a.395.395 0 01-.596-.042 4.272 4.272 0 01-.86-2.577c0-2.298 1.81-4.178 4.07-4.273l.18-.004h6.085l-1.634-1.646a.4.4 0 01-.087-.43l.036-.07.05-.062.148-.148a.395.395 0 01.498-.051z",
  fill: "#212121",
  fillRule: "nonzero"
}));

function SvgAtomsIconSwitchinline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref, _ref2);
}

export default SvgAtomsIconSwitchinline;